import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    height: 50,
    marginBottom: '1rem',
  },
  headerText: {
    fontSize: 32,
    color: theme.palette.gray.efesDarkGray,
    fontWeight: 'bold',
    marginBottom: '1rem',
    textTransform: 'uppercase',
    [theme.breakpoints.down(1200)]: {
      fontWeight: 'normal',
      fontSize: 24,
    },
  },
  subHeaderText: {
    fontSize: 16,
    color: theme.palette.gray.efesBorder,
    [theme.breakpoints.down('lg')]: {
      color: theme.palette.gray.efesDarkGray,
      fontSize: 14,
    },
  },
  forgotPassword: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: theme.palette.primary.hover,
    },
    [theme.breakpoints.down(1200)]: {
      color: theme.palette.gray.efesDarkGray,
    },
  },
  divider: {
    borderTop: `1px solid ${theme.palette.gray.efesGray}`,
  },
  signUp: {
    color: theme.palette.primary.main,
    fontSize: 16,
    textTransform: 'uppercase',
    fontWeight: 'bold',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.hover,
    },
    [theme.breakpoints.down(1200)]: {
      color: theme.palette.gray.efesDarkGray,
    },
  },
  newUser: {
    gap: '1rem',
    '& > div': {
      color: theme.palette.gray.efesBorder,
    },
  },
  newUserHeader: {
    fontSize: 16,
    color: theme.palette.gray.efesBorder,
  },
  mailSentMessage: {
    textAlign: 'center',
    color: theme.palette.gray.efesBorder,
    fontSize: 16,
    marginBottom: '1rem',
  },
}));

export default useStyles;
